import { OverlayTrigger, Tooltip } from "react-bootstrap";

const CardAdmin = ({
  grupos,
  permissions_groups,
  role = true,
  loading,
  changeCheckPermission,
  permissionsForm,
  setPermissionsForm,
}) => {
  return (
    <div className="container">
      <div className="row row-cols-1 row-cols-lg-2 row-cols-xl-3 g-4">
        {grupos?.map((g, index) => (
          <div className="col" key={`${g.id}_${index}`}>
            <div className="card h-100">
              <div className="card-header">{g}</div>
              <div className="card-body">
                {permissions_groups &&
                  permissions_groups[g].map((e, key) => (
                    <div className="form-check" key={key}>
                      <input
                        className="form-check-input"
                        type="checkbox"
                        id={e.id.toString()}
                        checked={e.checked}
                        disabled={!role || e.disabled || loading}
                        onChange={() =>
                          changeCheckPermission(e, permissionsForm, setPermissionsForm)
                        }
                      />
                      <OverlayTrigger
                        placement="top"
                        delay={{
                          show: 100,
                          hide: 500,
                        }}
                        overlay={(props) => (
                          <Tooltip {...props} hidden={!e.roles?.length}>
                            <h6>Incluido en los roles:</h6>
                            <ul>
                              {e.roles?.map((role) => (
                                <li key={role.id}>{role.description}</li>
                              ))}
                            </ul>
                          </Tooltip>
                        )}
                      >
                        <label role="button" className="form-check-label" htmlFor={e.id.toString()}>
                          {e.description}
                        </label>
                      </OverlayTrigger>
                    </div>
                  ))}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default CardAdmin;
